<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [isLoading$]="isLoading$"
>
  <gc-text class="label">{{ data.label }}</gc-text>
  <app-file-handler
    [data]="data.fileData"
    [id]="data.id"
    [optionsButton]="showOptionsButton()"
    [disableUndo]="isDeviation()"
    (viewImages)="viewImages.emit()"
    (filesDownload)="filesDownload.emit($event)"
    (fileDelete)="fileDelete.emit($event)"
  />
</app-report-self-inspection-wrapper>
